module.exports = __webpack_public_path__ + "img/doc_1.056787f4.png";